import { getIntlLocale } from '@/libs/i18n/dateLocale'

export function parseNumberOrNull(value) {
  if (value === null || value === undefined || value === '') return null
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}

export function formatMetric(value) {
  const n = parseNumberOrNull(value)
  if (n === null) return '—'
  return n.toLocaleString(getIntlLocale(), { maximumFractionDigits: 1 })
}

export function formatCurrency(value) {
  const n = parseNumberOrNull(value)
  if (n === null || n === undefined) return '—'
  return n.toLocaleString(getIntlLocale(), {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function formatDate(dateString) {
  if (!dateString) return '—'
  try {
    const d = new Date(dateString)
    if (Number.isNaN(d.getTime())) return dateString
    return `${d.toLocaleDateString(getIntlLocale())} ${d.toLocaleTimeString(getIntlLocale(), { hour: '2-digit', minute: '2-digit' })}`
  } catch (e) {
    return dateString
  }
}

export function resolveRemaining({
  scheduledValue,
  currentFromTelemetry,
  currentFromApi,
  remainingFromApi,
}) {
  const currentValue = currentFromTelemetry ?? currentFromApi ?? 0
  const remaining = currentFromTelemetry != null
    ? (scheduledValue - currentValue)
    : (remainingFromApi ?? (scheduledValue - currentValue))

  return { currentValue, remaining }
}

export function getMaintenanceStatus(remaining, scheduledValue) {
  if (remaining <= 0) return 'overdue'
  const warningThreshold = Math.max(Number(scheduledValue) * 0.1, 0)
  if (remaining <= warningThreshold) return 'dueSoon'
  return 'onTime'
}

export function mapMaintenanceItem(plan, telemetryHourmeter, telemetryOdometer, apiHourmeter, apiOdometer) {
  const isHourmeter = !!plan.hourmeter
  const scheduledValue = parseNumberOrNull(isHourmeter ? plan.hourmeter : plan.odometer) ?? 0
  const currentFromTelemetry = isHourmeter ? telemetryHourmeter : telemetryOdometer
  const currentFromApi = parseNumberOrNull(isHourmeter ? apiHourmeter : apiOdometer)
  const remainingFromApi = parseNumberOrNull(isHourmeter ? plan.hourmeterLeft : plan.odometerLeft)

  const { currentValue, remaining } = resolveRemaining({
    scheduledValue,
    currentFromTelemetry,
    currentFromApi,
    remainingFromApi,
  })

  const status = getMaintenanceStatus(remaining, scheduledValue)
  const progress = scheduledValue > 0
    ? Math.min(100, Math.max(0, (currentValue / scheduledValue) * 100))
    : 0

  return {
    id: plan.id,
    planName: plan.planName || '',
    name: plan.name || '',
    scheduledValue,
    remaining,
    currentValue,
    isHourmeter,
    unit: isHourmeter ? 'h' : 'Km',
    status,
    progress,
  }
}

export function extractHorHod(telemetryItems = []) {
  const hourmeter = telemetryItems.find(item => item.code === 'hor')
  const odometer = telemetryItems.find(item => item.code === 'hod')

  return {
    hourmeter: parseNumberOrNull(hourmeter?.value),
    odometer: parseNumberOrNull(odometer?.value),
  }
}

export const STATUS_META = {
  overdue: { variant: 'danger', icon: 'AlertCircleIcon', labelKey: 'Overdue:' },
  dueSoon: { variant: 'warning', icon: 'ClockIcon', labelKey: 'Due soon' },
  onTime: { variant: 'success', icon: 'CheckCircleIcon', labelKey: 'On time' },
}
